import {MetaTags} from '@frontend/components/MetaTags'
import {ResponsiveLayout} from '@frontend/components/ResponsiveLayout'
import {trans} from '@frontend/helpers'
import {useConfigureUi} from '@frontend/hooks'
import {PromoCards} from '@frontend/modules/layout/promo_cards/PromoCards'
import {HomePageRightPanel} from '@frontend/modules/public/ads/components/HomePageRightPanel'
import {RecentlyViewedAds} from '@frontend/modules/public/ads/components/list/RecentlyViewedAds'
import {PopularCategories} from '@frontend/modules/public/ads/components/PopularCategories'
import {HomePageAdsSection} from '@frontend/modules/public/home/components/HomePageAdsSection'
import {HomePageServicesSection} from '@frontend/modules/public/home/components/HomePageServicesSection'
import {useState} from 'react'

export default function HomePage() {

    // Настройка глобальных элементов интерфейса приложения.
    useConfigureUi(config => {
        config.topMenu.wrapInCard = false
        config.topMenu.stickToTop = false
        return config
    })

    const [
        showServices,
        setShowServices,
    ] = useState<boolean>(false)

    return (
        <div className="container-fluid container-xl">
            <MetaTags
                title={trans().common.home_page_title}
            />
            <PopularCategories className="px-sm-3" />
            <div className="flex-container-row pb-4">
                <div className="flex-1 px-sm-3">
                    <HomePageAdsSection
                        onAdsLoaded={action => setShowServices(action !== 'next')}
                    />
                    {showServices && (
                        <HomePageServicesSection />
                    )}
                    <ResponsiveLayout
                        desktop={null}
                        wideTablet={
                            <>
                                <RecentlyViewedAds
                                    standalone
                                    className="pt-3"
                                />
                                <div className="promo-cards-block-standalone">
                                    <div className="mt-4 fw-500 fs-5">
                                        {trans().ads.list.features}:
                                    </div>
                                    <PromoCards
                                        className="mt-4 grid-columns-md-2"
                                        utmSource="home_page"
                                    />
                                </div>
                            </>
                        }
                        mobile={
                            <PromoCards
                                className="mt-4 promo-cards-block-standalone"
                                utmSource="home_page"
                            />
                        }
                    />
                </div>
                <HomePageRightPanel />
            </div>
        </div>
    )
}
